import ee from "event-emitter";

export default ee();
